import { ADMIN, COMMON, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';
/**
 * * 관리자 관리 api
 */

export const managerApi = {
  read: () =>
    ifyouApi
      .get(`${ADMIN}/user-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detail: (userId: string) =>
    ifyouApi
      .get(`${ADMIN}/${userId}/user-detail`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (managerData) =>
    ifyouApi
      .post(`${ADMIN}/${managerData.userId}/user-update`, {
        userName: managerData.userName,
        userEmail: managerData.userEmail,
        userOrganization: managerData.userOrganization,
        userMaster: managerData.userMaster,
        userPlatform: managerData.userPlatform,
        userManagement: managerData.userManagement,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  // 작품 권한 리스트
  getProjectAuthList: (userId: string) =>
    ifyouApi
      .get(`${ADMIN}/${userId}/project-auth-list`)
      .then((res) => res.data.map((v, i) => ({ ...v, key: i })))
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  projectAuthUpdate: (userId: string, rows) =>
    ifyouApi
      .post(`${ADMIN}/${userId}/project-auth-update`, {
        rows: rows,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  projectAuthDelete: (userId: string, projectId: string) =>
    ifyouApi
      .post(`${ADMIN}/${userId}/project-auth-delete`, {
        project_id: projectId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

// 작품 권한 드롭다운 목록
export const fetchAuthDropListApi = () =>
  ifyouApi
    .post(`${COMMON}`, {
      func: 'standard',
      code: 'auth_kind',
    })
    .then((res) => res.data);
